<!-- [팝업] 라이브DI 검색 (완료된 라이브DI만 검색) -->
<template>
  <b-modal
    v-model="showLiveDiSelect"
    cancel-variant="outline-secondary"
    centered
    ok-title="추가"
    cancel-title="취소"
    size="xl"
    :title="'처방 '+ (isExclude ? '제외':'포함') + ' 라이브 DI 추가'"
    no-close-on-esc
    no-close-on-backdrop
    @ok.prevent="submit()"
    @close.prevent="close()"
    @cancel.prevent="close()"
  >
    <b-row
      class="mt-25"
    >
      <b-col
        cols="12"
        md="10"
        class="d-flex align-items-center justify-content-start"
      >
        <b-form-input
          v-model="query.liveInfoId"
          class="el-def mr-1"
          placeholder="ID"
          style="width:10%"
          @keyup.enter="refetchData()"
        />
        <v-select
          v-model="query.clientId"
          :options="codes.clients"
          :reduce="option => option.code"
          class="el-def mr-1"
          placeholder="제약사"
          style="width:200px;"
        />
        <b-form-input
          v-model="query.brandName"
          class="el-def mr-1"
          placeholder="제품명"
          style="width:30%;"
          @keyup.enter="refetchData()"
        />
        <b-form-input
          v-model="query.liveDiTitle"
          class="el-def mr-1"
          placeholder="노출 메시지"
          style="width:40%;"
          @keyup.enter="refetchData()"
        />
        <b-form-datepicker
          v-model="query.searchStartDate"
          class="el-def mr-1"
          placeholder="노출기간(Fr)"
          style="width:250px;"
        />
        ~
        <b-form-datepicker
          v-model="query.searchEndDate"
          class="el-def ml-1"
          placeholder="노출기간(To)"
          style="width:250px;"
        />
      </b-col>
      <!-- Search -->
      <b-col
        cols="12"
        md="2"
        class="d-flex align-items-center justify-content-end"
      >
        <b-button
          variant="primary"
          class="btn-search"
          @click.prevent="refetchData()"
        >
          조회
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mt-25">
      <span class="ml-25">노출 종료된 라이브 DI 리스트 [{{ totalRecords }}]건</span>
    </b-row>
    <b-row class="mt-1">
      <b-table
        ref="refLiveDiTable"
        primary-key="id"
        :items="fetchLiveDis"
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDesc"
        responsive
        sticky-header="460px"
        selectable
        select-mode="multi"
        class="position-relative"
        @row-selected="onRowSelectedLiveDi"
        @row-dblclicked="onRowDblClickedLiveDi"
      >
        <template #cell(createDate)="data">
          <span class="text-nowrap">
            {{ data.value | $dateFormatter('YYYY-MM-DD') }}
          </span>
        </template>
        <template #cell(modifyDate)="data">
          <span class="text-nowrap">
            {{ data.value | $dateFormatter('YYYY-MM-DD') }}
          </span>
        </template>
        <template #cell(liveDiPeriod)="data">
          <span class="text-nowrap">
            {{ data.item.liveDiStartDate | $dateFormatter('YYYY-MM-DD') }} ~ {{ data.item.liveDiEndDate | $dateFormatter('YYYY-MM-DD') }}
          </span>
        </template>
      </b-table>
    </b-row>
    <!-- <b-row>
      <b-col cols="12">
        <b-pagination
          v-model="currPage"
          :total-rows="totalRecords"
          limit="10"
          per-page="10"
          align="center"
        />
      </b-col>
    </b-row> -->
  </b-modal>
</template>

<script>
import dayjs from "dayjs"
import axios from '@axios'
import {
  ref, onMounted, getCurrentInstance,
} from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { errorFormatter, dateFormatter } from '@core/utils/filter'
import vSelect from "vue-select"

export default {
  components: {
    vSelect,
  },

  props: {
    showLiveDiSelect: {
      type: Boolean,
      required: true,
    },
    selectedValue: {
      type: Array,
      required: false,
      default: () => [],
    },
    isExclude: {
      type: Boolean,
      required: false,
      default: false,
    },
    filterType: {
      type: Number,
      required: true,
    },
  },

  setup(props, { emit }) {
    onMounted(() => {
      fetchCodes()
    })
    const instance = getCurrentInstance()
    const bvModal = instance.proxy.$bvModal

    const toast = useToast()

    // Query Data
    const query = ref({
      liveInfoId: null,
      clientId: null,
      brandName: null,
      liveDiTitle: null,
      searchStartDate: dayjs().add(-6, 'month').format('YYYY-MM-DD'),
      searchEndDate: dayjs().format('YYYY-MM-DD'),
    })
    // Query Data End.

    // Set Codes
    const codes = ref({
      clients: [],
    })

    const fetchCodes = () => {
      axios.get("/fa/druginfo/codes")
        .then(rs => {
          const {
            clients,
          } = rs.data
          codes.value.clients = clients
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: '코드 데이터를 불러오는데 실패하였습니다.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }
    // Set Codes End.

    // Main Table Config
    const refLiveDiTable = ref(null)
    const sortBy = ref('liveInfoId')
    const isSortDesc = ref(true)
    // const currPage = ref(1)
    const totalRecords = ref(0)
    const tableColumns = [
      {
        key: 'liveInfoId', label: 'Id', sortable: true, thStyle: { width: '10%' },
      },
      {
        key: 'clientName', label: '제약사', sortable: true, thStyle: { width: '20%' },
      },
      { key: 'brandName', label: '제품명', sortable: true },
      { key: 'liveDiTitle', label: '라이브 DI 노출메시지', sortable: true },
      { key: 'liveDiPeriod', label: '라이브 DI 노출기간', sortable: true },
    ]
    const sortFieldMap = {
      liveDiPeriod: 'liveDiStartDate',
    }
    const refetchData = () => {
      refLiveDiTable.value.refresh()
    }
    // watch([currPage], () => {
    //   refetchData()
    // })
    const selectedRows = ref([])
    const onRowSelectedLiveDi = items => {
      selectedRows.value = items
    }
    const onRowDblClickedLiveDi = item => {
      selectedRows.value = [item]
      submit()
    }
    // Main Table Config End.

    const fetchLiveDis = (ctx, callback) => {
      if (!query.value.searchStartDate || !query.value.searchEndDate) {
        toast({
          component: ToastificationContent,
          props: {
            title: '조회 기간을 설정하세요',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        })
        callback([])
        totalRecords.value = 0
        return
      }

      axios.post("/fa/druginfo/quick-search/live-di", {
        search: {
          query: query.value,
          liveType: 2, // 게시종료
          isIncludeAll: false,
        },
        sort: {
          predicate: sortFieldMap[sortBy.value] || sortBy.value,
          reverse: isSortDesc.value,
        },
        // pagination: {
        //   number: currPage.value,
        //   count: 10,
        // },
      })
        .then(rs => {
          const { items, totalRecord } = rs.data

          // // 선택된 행 강조
          // this.items.forEach(row => {
          //   if (liveDiSelectIds.value.includes(row.liveInfoId)) {
          //     refLiveDiTable.value.toggleRowSelection(row, true)
          //   }
          // })
          callback(items)
          totalRecords.value = totalRecord
        })
        .catch(error => {
          toast({
            component: ToastificationContent,
            props: {
              title: errorFormatter(error, '라이브DI 데이터 조회에 실패하였습니다.'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    const close = () => {
      query.value = {
        liveInfoId: null,
        clientId: null,
        brandName: null,
        liveDiTitle: null,
        searchStartDate: dayjs().add(-6, 'month').format('YYYY-MM-DD'),
        searchEndDate: dayjs().format('YYYY-MM-DD'),
      }
      emit('close', null)
    }

    const submit = () => {
      if (!selectedRows.value || selectedRows.value.length === 0) {
        toast({
          component: ToastificationContent,
          props: {
            title: '라이브DI를 선택하세요',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        })
        return
      }

      const newCount = selectedRows.value.filter(
        item => !props.selectedValue.includes(item.liveInfoId),
      ).length

      if (props.selectedValue.length + newCount > 5) {
        bvModal.msgBoxOk('라이브DI는 포함/제외 각각 최대 5개까지 추가할 수 있습니다.', {
          okTitle: '확인',
        })
        return
      }
      const selectedLiveDiList = []
      selectedRows.value.forEach(item => {
        selectedLiveDiList.push({
          filterId: item.liveInfoId,
          filterType: props.filterType,
          isExclude: props.isExclude,
          clientName: item.clientName,
          brandName: item.brandName,
          liveDiTitle: item.liveDiTitle,
          liveDiPeriod: `${dateFormatter(item.liveDiStartDate, 'YYYY-MM-DD')} ~ ${dateFormatter(item.liveDiEndDate, 'YYYY-MM-DD')}`,
        })
      })

      emit('close', selectedLiveDiList)
    }

    return {
      query,
      codes,
      fetchCodes,
      close,
      submit,
      refLiveDiTable,
      sortBy,
      // currPage,
      isSortDesc,
      totalRecords,
      tableColumns,
      refetchData,
      onRowSelectedLiveDi,
      onRowDblClickedLiveDi,
      fetchLiveDis,
    }
  },
}
</script>
